import { env } from '~/lib/config';

export function profilerInit() {
    if ('1' === env.VITE_APP_SYMFONY_PROFILER_TOOLBAR_ENABLED) {
        // Loads and runs 'load_toolbar_spa.js' from the composer package
        // MGDSoft/symfony-profiler-spa through the ProfilerToolbarController.
        // No need to await
        void import(
            /* @vite-ignore */
            `${env.VITE_API_BASE_URL}/profiler-toolbar/serve-init-script`
        );
    }
}
